import { render, staticRenderFns } from "./card-header.vue?vue&type=template&id=3e8c404a&scoped=true&"
import script from "./card-header.vue?vue&type=script&lang=ts&"
export * from "./card-header.vue?vue&type=script&lang=ts&"
import style0 from "./card-header.vue?vue&type=style&index=0&id=3e8c404a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c404a",
  null
  
)

export default component.exports